// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 6450) return "static/chunks/6450-6baeb3711facdaf8.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "95d594cecb2a326e" + ".js";
};